import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=031a5af1&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PostDetail.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a5af1",
  null
  
)

export default component.exports